import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const UpdateProfileService = (fullname: string) => {
  return HTTP_CLIENT.patch(`${Endpoint.settings.updateProfile}`, {
    fullname,
  });
};

const UpdatePasswordService = (
  currentPassword: string,
  newPassword: string
) => {
  return HTTP_CLIENT.patch(`${Endpoint.settings.updatePassword}`, {
    current_password: currentPassword,
    password: newPassword,
  });
};

export { UpdateProfileService, UpdatePasswordService };
